import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Checkbox, Button } from 'semantic-ui-react';
import ReactTable from 'react-table';
import * as _ from 'lodash';

import * as actions from '../state/chargeLimit/actions';

import { RestrictionType } from '../helpers/SiteSetupConstants';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { TrackedInput, TrackedRadio } from 'Components';
import { InputMode } from 'Common/FormEnum';

class ChargeLimit extends Component {
  state = {
    showDialog: false,
  };

  renderEditable = cellInfo => {
    let currentValue = _.find(this.props.chargeByStatusData, {
      Status: cellInfo.original.Status,
    }).MealCount;

    if (!currentValue) {
      currentValue = '';
    }

    return (
      <TrackedInput
        initialValue={
          _.find(this.props.initalChargeByStatusData, {
            status: cellInfo.original.Status,
          }).mealCount
        }
        style={{ height: '30px', margin: '0 auto' }}
        value={currentValue}
        maxLength={2}
        size={'mini'}
        disabled={cellInfo.original.NoRestrictions}
        onChange={e => {
          this.props.restrictionsEditGridLine(
            cellInfo.original.Status,
            e.target.value
          );
        }}
        mode={InputMode.Integer}
      />
    );
  };

  handleDialog(result) {
    if (result) {
      this.props.removeStudentRestrictions(
        this.props.siteId,
        this.props.siteDescription
      );
    }
    this.setState({ showDialog: false });
  }

  render() {
    const {
      restrictionType,
      initialRestrictionType,
      isReadOnly,
      setHasRestrictions,
    } = this.props;

    return (
      <div>
        <Grid padded>
          <Grid.Row>
            <Grid.Column width={8}>
              <TrackedRadio
                groupName={'Restrictions'}
                label="NO RESTRICTIONS"
                name="hasRestrictions"
                value={RestrictionType.None}
                initialValue={initialRestrictionType}
                onChange={() => {
                  setHasRestrictions(RestrictionType.None);
                }}
                checked={restrictionType === RestrictionType.None}
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <Button
                icon="trash"
                labelPosition="right"
                content="Remove Student Level Restrictions"
                disabled={isReadOnly}
                onClick={() => {
                  this.setState({ showDialog: true });
                }}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <TrackedRadio
                initialValue={initialRestrictionType}
                groupName={'Restrictions'}
                label="RESTRICT BY SPECIFYING A MAX. # OF MEALS CHARGED"
                name="hasRestrictions"
                value={RestrictionType.Site}
                onChange={() => {
                  setHasRestrictions(RestrictionType.Site);
                }}
                checked={restrictionType === RestrictionType.Site}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              {restrictionType === RestrictionType.Site ? (
                <ReactTable
                  minRows={7}
                  loading={false}
                  data={this.props.chargeByStatusData}
                  resizable={false}
                  className="-striped -highlight"
                  showPagination={false}
                  style={{ width: '50%' }}
                  columns={[
                    {
                      columns: [
                        {
                          Header: 'MEAL STATUS',
                          accessor: 'Status',
                          filterable: false,
                          resizable: false,
                          style: {
                            fontWeight: 'bold',
                            textAlign: 'center',
                          },
                          width: 95,
                        },
                        {
                          Header: x => {
                            return (
                              <span>
                                MAXIMUM ALLOWED <br />
                                COUNT OF MEALS CHARGE
                              </span>
                            );
                          },
                          accessor: 'MaxChargedMealCntAllowed',
                          filterable: false,
                          resizable: false,
                          Cell: this.renderEditable,
                          style: { textAlign: 'center' },
                          maxWidth: 230,
                        },
                        {
                          Header: 'NO RESTRICTIONS',
                          accessor: 'NoRestrictions',
                          maxWidth: 135,
                          sortable: true,
                          Cell: ({ original }) => {
                            return (
                              <div style={{ textAlign: 'center' }}>
                                <Checkbox
                                  checked={original.NoRestrictions === true}
                                  onChange={(e, data) => {
                                    this.props.setNoRestriction(
                                      original.Status
                                    );
                                  }}
                                />
                              </div>
                            );
                          },
                        },
                      ],
                    },
                  ]}
                />
              ) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <YesNoDialog
          showDialog={this.state.showDialog}
          title="Confirm"
          question={`Are you sure you want to remove all student level charge restrictions at ${
            this.props.siteDescription
          }?`}
          yesCallback={() => {
            this.handleDialog(true);
          }}
          noCallback={() => {
            this.handleDialog(false);
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ SiteSetupState }) => {
  const { chargeLimit, siteDetails } = SiteSetupState;

  return {
    restrictionType: chargeLimit.restrictionType,
    chargeByStatusData: chargeLimit.data,
    siteId: siteDetails.data.Id,
    siteDescription: siteDetails.data.Description,
    initalChargeByStatusData: chargeLimit.initialData,
    initialRestrictionType: chargeLimit.initialRestrictionType,
  };
};

export default connect(
  mapStateToProps,
  actions
)(ChargeLimit);



// WEBPACK FOOTER //
// ./src/pages/sitesetup/components/ChargeLimit.js